var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import * as React from 'react';
export var Loading = function () {
    return React.createElement(Flex, { center: true, stretch: true },
        React.createElement(CircularProgress, null));
};
/**
 * Wrapper around div to simplify flex layouts.
 * Used to get rid of the inline styling in most popular scenarios, not as a comprehensive flex-box layout tool.
 */
export var Flex = function (_a) {
    var row = _a.row, column = _a.column, wrap = _a.wrap, grow = _a.grow, alignCenter = _a.alignCenter, justifyCenter = _a.justifyCenter, className = _a.className, center = _a.center, stretch = _a.stretch, children = _a.children, props = __rest(_a, ["row", "column", "wrap", "grow", "alignCenter", "justifyCenter", "className", "center", "stretch", "children"]);
    var classes = useFlexStyles();
    var classNames = className || '';
    if (row)
        classNames += ' ' + classes.row;
    if (column)
        classNames += ' ' + classes.column;
    if (grow)
        classNames += ' ' + classes.grow;
    if (center)
        classNames += ' ' + classes.center;
    if (alignCenter)
        classNames += ' ' + classes.alignCenter;
    if (justifyCenter)
        classNames += ' ' + classes.justifyCenter;
    if (stretch)
        classNames += ' ' + classes.stretch;
    if (wrap)
        classNames += ' ' + classes.wrap;
    return React.createElement("div", __assign({ className: classNames }, props), children);
};
var useFlexStyles = makeStyles({
    row: {
        display: "flex",
        flexDirection: "row"
    },
    wrap: {
        flexWrap: "wrap"
    },
    center: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    alignCenter: {
        display: "flex",
        alignItems: "center",
    },
    justifyCenter: {
        display: "flex",
        justifyContent: "center"
    },
    column: {
        display: "flex",
        flexDirection: "column"
    },
    grow: {
        flexGrow: 1
    },
    stretch: {
        height: '100%',
        width: '100%',
    }
});
//# sourceMappingURL=flex.js.map